import { render, staticRenderFns } from "./CreatePatientTreatment.vue?vue&type=template&id=e7c27338&scoped=true&"
import script from "./CreatePatientTreatment.vue?vue&type=script&lang=js&"
export * from "./CreatePatientTreatment.vue?vue&type=script&lang=js&"
import style0 from "./CreatePatientTreatment.vue?vue&type=style&index=0&id=e7c27338&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c27338",
  null
  
)

export default component.exports